import { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { selectBuildingCard } from 'shared/selectors/buildingCard';
import { getBuildingTitle } from 'shared/utils/buildingMainBlock';
import { getFloatingHeaderArea, getFloatingHeaderNavItems, getFloatingHeaderRate } from 'shared/utils/floatingHeader';

import { FloatingHeader } from './FloatingHeader';
import { useFloatingHeaderScroll } from './hooks';

export const FloatingHeaderContainer = () => {
  const card = useSelector(selectBuildingCard);
  const headerRef = useRef<HTMLDivElement>(null);
  const navItems = useMemo(() => getFloatingHeaderNavItems(card), [card]);
  const { isVisible, activeIndex, scrollToTarget } = useFloatingHeaderScroll(
    headerRef,
    navItems.map(({ targetId }) => targetId),
  );

  return (
    <FloatingHeader
      ref={headerRef}
      isVisible={isVisible}
      title={getBuildingTitle(card)}
      navItems={navItems}
      activeIndex={activeIndex}
      onNavClick={index => scrollToTarget(navItems[index].targetId)}
      area={getFloatingHeaderArea(card.offersAreas)}
      rate={getFloatingHeaderRate(card.rates)}
      representative={card.representative}
    />
  );
};
